import React from 'react';

import {
  ButtonWrapper,
  ToolbarContainer,
  ToolbarWrapper,
} from './EditorToolbar.styled';
import {
  BoldButton,
  BulletListButton,
  ItalicButton,
  NumberListButton,
  StrikeButton,
  UnderlineButton,
} from './ToolbarButtons';

const buttonStyles = {
  buttonWrapper: '',
  button: '',
  active: 'active-button-style',
};

type Props = {
  editorState: any;
  handleChange: () => void;
};

function EditorToolbar({ editorState, handleChange }: Props) {
  const externalProps = {
    getEditorState: () => editorState,
    setEditorState: handleChange,
    theme: buttonStyles,
    buttonProps: {
      tabIndex: -1,
    },
  };

  return (
    <ToolbarContainer>
      <ToolbarWrapper>
        <ButtonWrapper>
          <BoldButton {...externalProps} />
        </ButtonWrapper>
        <ButtonWrapper>
          <ItalicButton {...externalProps} />
        </ButtonWrapper>
        <ButtonWrapper>
          <StrikeButton {...externalProps} />
        </ButtonWrapper>
        <ButtonWrapper>
          <UnderlineButton {...externalProps} />
        </ButtonWrapper>
        <ButtonWrapper>
          <NumberListButton {...externalProps} />
        </ButtonWrapper>
        <ButtonWrapper>
          <BulletListButton {...externalProps} />
        </ButtonWrapper>
      </ToolbarWrapper>
    </ToolbarContainer>
  );
}

export default EditorToolbar;
